export class Analitika{
    static instance = null;
    
    constructor(options){
        // Singleton pattern - ensure only one instance
        if (Analitika.instance) {
            console.warn('Analitika instance already exists. Returning existing instance.');
            return Analitika.instance;
        }
        
        // Store the instance
        Analitika.instance = this;
        
        var _this = this;

        this.options =
        {
            api: "http//localhost:5001",
            hermes_client: "http//localhost:5000",
            destination: 0,
            url: 'undefined',
            location: 0,
            hermes: true,
            callback: null
        };

        for (const [key, value] of Object.entries(options)) {
            this.options[key] = value;
        }
        
        this.location = this.options.location;
        this.sessionStartTime = null;
        this.initiator = '';
        this.session = {};
        this.statusData = {location: this.location,
                       name: 'miza',
                       status: this.options.url,
                       data:{online: true} ,
                       health: 0,
                       memory: 0
                    };

        let hermes = import.meta.env.VITE_HERMES;
        console.log("VITE_HERMES",hermes);
        //if(hermes == 'true') {
        console.log('Analitika constructor - location:', _this.location, 'hermes:', _this.options.hermes);
        if(_this.location == 0) {
                console.log('Location is 0, calling getHermesData');
                if(_this.options.hermes) _this.getHermesData(this.options.onData, this.options.callback);
        }else{
                console.log('Location is > 0, calling appReport and starting periodic timer');
                _this.appReport();
                // Start periodic appReport if location > 0
                if (_this.location > 0) {
                    _this.startPeriodicAppReport();
                }
        }      
    }

    contactHermes(){

    }

    setStatus(status, more, health){

        if( health == undefined ) health=0;
        this.statusData.health = health;
        this.statusData.status = status;
        this.statusData.data.more =more;
    }
    
    setStatusData(field, value){
        this.statusData.data[field] = value;
    }
    setStatusOneTimeData(value){
        this.statusData.data.more = value;
    }

    setLocation(newLocation){
        this.location = newLocation;
        this.statusData.location = newLocation;
        
        if (newLocation > 0) {
            // Start periodic appReport if not already running
            if (!this.appReportTimer) {
                this.startPeriodicAppReport();
            }
        } else {
            // Stop periodic appReport if location becomes 0
            this.stopPeriodicAppReport();
        }
    }

    updateOptions(newOptions){
        // Update options for existing instance
        for (const [key, value] of Object.entries(newOptions)) {
            this.options[key] = value;
        }
        console.log('Analitika options updated:', this.options);
    }

    startSession(initiator){
        var _this = this;
        this.initiator = initiator;
        this.sessionStartTime = Date.now();
        console.log('[analitika] startSession', {
            initiator: initiator || '(none)',
            location: this.location,
            destination: this.options.destination,
            sessionStartTime: this.sessionStartTime,
        });
        this.cardStartTime = [];
        this.session = {
            events: [], 
            stats: {
                card_view: {}, 
                favorit: {}, 
                card_view_time: {}
            }, 
            statsTab: {
                tab_view: {},
                tab_view_time: {}
            },
            onboarding_compleded: 0, 
            wizzard_cancelations: [], 
            wizzard_completion_num: 0,
            ai_wizz_triggered: 0,
            ai_wizz_completed: 0,
            codes_generated: 0,
            modules: {},
            poi_categories: {}};
        this.callHermes('session-start', {});    
    }
    report(event, data){
        if(this.location > 0) this.send(event, data)
    }

    send(event, data){
        var _this = this;
        /*
        try{
         let tmt = null;
            console.log('report_js_error faul' + tmt.err);
    }catch {
        throw 'zanalasc error';
    }
    */
        if (this.sessionStartTime == null) {
            console.warn('[analitika] event ignored — no active session (startSession not called?)', { event, data });
            return;
        }
        if (!Array.isArray(this.session.events)) {
            console.warn('[analitika] event ignored — session.events missing', { event, data });
            return;
        }
        var memoryInfo = null;
        if(window.performance != undefined && window.performance.memory != undefined && window.performance.memory.jsHeapSizeLimit != undefined)
            memoryInfo = {
                jsHeapSizeLimit: window.performance.memory.jsHeapSizeLimit,
                totalJSHeapSize: window.performance.memory.totalJSHeapSize,
                usedJSHeapSize: window.performance.memory.usedJSHeapSize
            };
        this.session.events.push({event: event, data: {event: data, memoryInfo: memoryInfo}, time: Date.now()-this.sessionStartTime});
       if(memoryInfo != null && window.performance.memory.usedJSHeapSize/window.performance.memory.jsHeapSizeLimit > 0.5){
        this.session.events.push({event: 'memory', data: {event: data, memoryInfo: {
            jsHeapSizeLimit: window.performance.memory.jsHeapSizeLimit,
            totalJSHeapSize: window.performance.memory.totalJSHeapSize,
            usedJSHeapSize: window.performance.memory.usedJSHeapSize}
        }, time: Date.now()-this.sessionStartTime});
       }
        this.generateStats(event, data);
        console.log('[analitika] event', {
            event,
            data,
            location: this.location,
            elapsedMs: Date.now() - this.sessionStartTime,
            eventCount: this.session.events.length,
        });
    }



    generateStats(event, data){
        var _this = this;
        switch (event){
            case 'add_favorit': 
                _this.session.stats.favorit[data.poi] = 1;
                break;
            case 'remove_favorit': 
                delete (_this.session.stats.favorit[data.poi] );
                break;
            case 'qr_path_created': 
                //if(_this.session.codes_generated[data.poi] != undefined) _this.session.codes_generated[data.poi]++;
               _this.session.codes_generated++ ;
                break;
            case 'poi_click': 
                if(typeof data === 'object' &&  data != null && data.poi > 0){
                    _this.cardStartTime[data.poi] =  Date.now();
                    _this.session.stats.card_view[data.poi] = 1;
                    var categoryKey = data.category;
                    if (!categoryKey && data.mainCategory) categoryKey = data.mainCategory;
                    if (categoryKey) {
                        categoryKey = String(categoryKey);
                        if (_this.session.poi_categories[categoryKey] == undefined) _this.session.poi_categories[categoryKey] = 1;
                        else _this.session.poi_categories[categoryKey]++;
                    }
                }
                break;
            case 'hide_card': 
                if(typeof data === 'object' &&  data != null  && data.poi > 0){
                    var time =  Date.now();
                    if(_this.cardStartTime[data.poi] != undefined){
                        time = time - _this.cardStartTime[data.poi];
                        if( _this.session.stats.card_view_time[data.poi] != undefined ) _this.session.stats.card_view_time[data.poi] += time;
                        else  _this.session.stats.card_view_time[data.poi]  = time;
                    }
                }
                break;  
            case 'skip_onboarding':
                    _this.session.onboarding_compleded = data.progress;
                    break;    
            case 'skip_wizzard':
                    if(data != null && data.step != undefined) _this.session.wizzard_cancelations.push(data.step);
                    break;
            case 'complete_wizzard':
                    _this.session.wizzard_completion_num++;
                    break;
            case 'ai_wizz_triggered':
                    _this.session.ai_wizz_triggered++;
                    break;
            case 'ai_wizz_completed':
                    _this.session.ai_wizz_completed++;
                    break;
            case 'module_click':
                    if (typeof data === 'object' && data != null) {
                        var moduleKey = data.key;
                        if (!moduleKey && data.id) moduleKey = String(data.id);
                        else if (!moduleKey && data.module === 'map') moduleKey = 'map';
                        else if (!moduleKey && data.module === 'scenarios') moduleKey = 'scenarios';
                        else if (!moduleKey && data.index !== undefined) moduleKey = data.module + '-' + data.index;
                        else if (!moduleKey && data.module) moduleKey = data.module;
                        if (moduleKey) {
                            if (_this.session.modules[moduleKey] == undefined) _this.session.modules[moduleKey] = 1;
                            else _this.session.modules[moduleKey]++;
                        }
                    }
                    break;
            case 'complete_onboarding':
                _this.session.onboarding_compleded = 7;
                break;      
            case 'tab_start':
                if(typeof data === 'object' &&  data != null && data.tab.length > 0){
                    if( _this.session.statsTab.tab_view[data.tab] == undefined ) {
                        _this.session.statsTab.tab_view[data.tab] = 1
                    }else {
                        _this.session.statsTab.tab_view[data.tab] = _this.session.statsTab.tab_view[data.tab] + 1
                    }
                    _this.session.statsTab.tab_view_time[data.tab] = Date.now();
                }
                break;
            case 'tab_end':
                _this.session.statsTab.tab_view_time[data.tab] = Date.now() - _this.session.statsTab.tab_view_time[data.tab];
                break;            
        }
    }

    closeSession(data, callback){
        var _this = this;
        const eventCount = Array.isArray(this.session.events) ? this.session.events.length : 0;
        console.log('[analitika] closeSession called', {
            location: this.location,
            destination: this.options.destination,
            sessionStartTime: this.sessionStartTime,
            eventCount,
            willSendToApi: this.location > 0,
        });
        if(!(this.location > 0)){ 
            console.warn('[analitika] closeSession skipped — location is 0, saveSessionAnalytics not called', {
                session: this.session,
            });
            if(typeof(callback) === 'function') callback();
            return false;
        }
        this.send('session_end', data);
        
        if(data == undefined) data = {};

        let sessionEndTime =  Date.now();
        this.session.duration = sessionEndTime - this.sessionStartTime;
        this.session.location = this.location;
        this.session.destination =this.options.destination;
        this.session.data = data;
        this.session.data.sessionStartTime = this.sessionStartTime;
        this.session.data.sessionEndTime = sessionEndTime;
        if (this.session.modules && Object.keys(this.session.modules).length > 0) {
            this.session.data.modules = this.session.modules;
        }
        if (this.session.poi_categories && Object.keys(this.session.poi_categories).length > 0) {
            this.session.data.poi_categories = this.session.poi_categories;
        }
        console.log('[analitika] closeSession payload ready', {
            durationMs: this.session.duration,
            eventCount: this.session.events.length,
            api: this.options.api,
            session: this.session,
        });

        if(this.location > 0) this.callApi('LocationRequests', 'saveSessionAnalytics', this.session , function(response){
            console.log('[analitika] saveSessionAnalytics response', response);
            if(typeof(callback) === 'function') callback(response);
        });
        this.callHermes('session-close', {});
    }



    start_interact(poiProperties){
        //console.log('start_interact'+(poiProperties.presentation  != undefined)+(poiProperties.presentation.aditional != undefined )+Array.isArray(poiProperties.presentation.aditional.screens) +poiProperties.presentation.aditional.screens.length)
        if(this.location > 0 
                && poiProperties.presentation  != undefined 
                && poiProperties.presentation.aditional != undefined 
                && Array.isArray(poiProperties.presentation.aditional.screens) 
                && poiProperties.presentation.aditional.screens.length > 0 ) 
            this.send_app_request({location: this.location, action: 'video_play', screens: poiProperties.presentation.aditional.screens});
    }
    stop_interact(){
        if(this.location > 0) this.send_app_request({location:  this.location, action: 'video_unplay'});
    }


    //
    send_app_request(data){
        var _this = this;
        var xmlhttp;
        if (window.XMLHttpRequest)
            xmlhttp=new XMLHttpRequest();
        else
            xmlhttp=new ActiveXObject("Microsoft.XMLHTTP");
    
    
        xmlhttp.onreadystatechange=function()
        {
            if (xmlhttp.readyState==4 &&  xmlhttp.status==200)
            {
                console.log(xmlhttp.responseText);
            }
        }
        xmlhttp.open('POST',this.options.hermes_client+"/send_app_request", true);
        //xmlhttp.setRequestHeader("Content-Type", "application/json; charset = UTF-8");
        xmlhttp.send(JSON.stringify(data));
    }

    printPDF(base64Data){
        var _this = this;
        if(this.location == 0) return;
        var xmlhttp;
        if (window.XMLHttpRequest)
            xmlhttp=new XMLHttpRequest();
        else
            xmlhttp=new ActiveXObject("Microsoft.XMLHTTP");
    
    
        xmlhttp.onreadystatechange=function()
        {
            if (xmlhttp.readyState==4 &&  xmlhttp.status==200)
            {
                console.log(xmlhttp.responseText);
            }
        }
        xmlhttp.open('POST',this.options.hermes_client+"/print-pdf", true);
        //xmlhttp.setRequestHeader("Content-Type", "application/json; charset = UTF-8");
        xmlhttp.send(JSON.stringify({toprint: base64Data}));
    }


    callApi(iface, method, parameters, callback){
        var _this = this;
        const jsonRequest = this.formatRequest(iface, method, parameters);

        console.log('[analitika] callApi', { iface, method, url: this.options.api });
        var xmlhttp;
        if (window.XMLHttpRequest)
            xmlhttp=new XMLHttpRequest();
        else
            xmlhttp=new ActiveXObject("Microsoft.XMLHTTP");
    
    
        xmlhttp.onreadystatechange=function()
        {
            if (xmlhttp.readyState==4 )
            {
                if(xmlhttp.status==200)
                {
                    var response = {error:{type: 'server', msg: 'Could not parse response'}}
                    try{
                        response = JSON.parse(xmlhttp.responseText);
                    }catch{
    
                    }
                    if(typeof(callback) === 'function') callback(response);
                }
                else{
                    console.error('[analitika] callApi failed', { iface, method, status: xmlhttp.status, url: _this.options.api });
                    if(typeof(callback) === 'function') callback({error:{type: 'server', msg: 'error at server side, status:'+xmlhttp.status}});
                }

            }
        }
        xmlhttp.open('POST',this.options.api, true);
        //xmlhttp.setRequestHeader("Content-Type", "application/json; charset = UTF-8");
        //xmlhttp.setRequestHeader('Access-Control-Allow-Origin', '*');
        xmlhttp.send(jsonRequest);
    }
    getLocation(){
        var _this = this;
        var xmlhttp;
        if (window.XMLHttpRequest)
            xmlhttp=new XMLHttpRequest();
        else
            xmlhttp=new ActiveXObject("Microsoft.XMLHTTP");
    
    
        xmlhttp.onreadystatechange=function()
        {
            if (xmlhttp.readyState==4 &&  xmlhttp.status==200)
            {
                _this.setLocation(parseInt(xmlhttp.responseText));
                // Call appReport after location is retrieved
                _this.appReport();
            }
        }
        xmlhttp.open('GET',this.options.hermes_client+"/get-location", true);
        xmlhttp.send();
    }
    getHermesData(onData, callback){
        var _this = this;
        var xmlhttp;
        if (window.XMLHttpRequest)
            xmlhttp=new XMLHttpRequest();
        else
            xmlhttp=new ActiveXObject("Microsoft.XMLHTTP");
    
    
        xmlhttp.onreadystatechange=function()
        {
            if (xmlhttp.readyState==4 &&  xmlhttp.status==200)
            {
                if(xmlhttp.responseText == 'unknown') {
                    console.log('old hermes version ');
                    _this.getLocation();
                }
                else{
                    try{
                        let data = JSON.parse(xmlhttp.responseText); 
                        _this.setLocation(parseInt(data.location));
                        _this.token = data.token;
                        if(typeof onData === "function"){
                            onData(_this.location,  _this.token);
                        }
                        if(typeof callback === "function"){
                            callback(_this.location,  _this.token);
                        }
                        // Call appReport after location is retrieved
                        _this.appReport();
                     }catch{
                       console.log('cannot parse data from hermes: '+xmlhttp.responseText)
                     }

                }

                
            }else if(xmlhttp.readyState==4 && xmlhttp.status !=200 ){
                if(typeof onData === "function"){
                    onData(0,'');
                }
                if(typeof callback === "function"){
                    callback(0,'');
                }
              setTimeout(function(){
                _this.getHermesData();
              }, 25000);
            }
        }
        xmlhttp.open('GET',this.options.hermes_client+"/get-data", true);
        xmlhttp.send();
    }
    getMessages(){
        var _this = this;
        var xmlhttp;

        if (window.XMLHttpRequest)
            xmlhttp=new XMLHttpRequest();
        else
            xmlhttp=new ActiveXObject("Microsoft.XMLHTTP");
    
    
        xmlhttp.onreadystatechange=function()
        {
            if (xmlhttp.readyState==4 &&  xmlhttp.status==200)
            {
                console.log('got  messages: ' +xmlhttp.responseText);
                switch(xmlhttp.responseText){
                    case 'miza_reload': window.location.reload(); break;
                }
            }
        }
        xmlhttp.open('POST',this.options.hermes_client+"/get-messages", true);
        xmlhttp.send();
    }

    appReport(callback){
        var _this = this;
        var xmlhttp;
        //var out = {};
        console.log('appReport called - location:', this.location, 'hermes_client:', this.options.hermes_client);

        if(this.location == 0) {
            console.log('appReport returning early - location is 0');
            return;
        }

        if (window.XMLHttpRequest)
            xmlhttp=new XMLHttpRequest();
        else
            xmlhttp=new ActiveXObject("Microsoft.XMLHTTP");
    
        
        xmlhttp.onreadystatechange=function()
        {
            if (xmlhttp.readyState==4 &&  xmlhttp.status==200)
            {
                console.log('got  server requests: ' +xmlhttp.responseText);
                try{
                    let data = JSON.parse(xmlhttp.responseText);
                    switch(data.action){
                        case 'reload': 
                        case 'restart':
                            //console.log('got  server requests action:' + data.action);
                            window.location.reload();
                            break;
                    }
                    if(data.localmesages != undefined && Array.isArray(data.localmesages))
                        data.localmesages.forEach((msg) => {
                            switch(msg){
                                case 'app_updated':
                                    break;
                                case 'data_updated':
                                        break;      
                                case 'reset-pedestrians':
                                    localStorage.removeItem('pedestrian')
                                    break;                                            
                            }
                        });
                   
                }catch{

                }
                if(typeof(callback) === 'function'){
                    callback();
                }
                
            }
        }


        var memoryInfo = null;
        if(window.performance != undefined && window.performance.memory != undefined && window.performance.memory.jsHeapSizeLimit != undefined)
            memoryInfo = {
                jsHeapSizeLimit: window.performance.memory.jsHeapSizeLimit,
                totalJSHeapSize: window.performance.memory.totalJSHeapSize,
                usedJSHeapSize: window.performance.memory.usedJSHeapSize
            };
       if(memoryInfo != null){
         this.setStatusData('memoryInfo', memoryInfo);
       }    




        console.log('Sending appReport to:', this.options.hermes_client+"/app-report");
        console.log('Status data being sent:', this.statusData);
        xmlhttp.open('POST',this.options.hermes_client+"/app-report", true);
        //xmlhttp.setRequestHeader("Content-Type", "application/json");
        xmlhttp.send(JSON.stringify(this.statusData));
        this.statusData.data.more = null;
        //return out;
    }

    startPeriodicAppReport(){
        var _this = this;
        // Clear any existing timer
        if (this.appReportTimer) {
            clearInterval(this.appReportTimer);
            this.appReportTimer = null;
        }
        // Start periodic appReport every 30 seconds
        this.appReportTimer = setInterval(function() {
            if (_this.location > 0) {
                console.log('Periodic appReport executing for location:', _this.location);
                _this.appReport();
            } else {
                // Stop the timer if location becomes 0
                console.log('Stopping periodic appReport - location is 0');
                clearInterval(_this.appReportTimer);
                _this.appReportTimer = null;
            }
        }, 30000); // 30 seconds = 30000 milliseconds
        console.log('Started periodic appReport every 30 seconds for location:', this.location);
    }

    stopPeriodicAppReport(){
        if (this.appReportTimer) {
            clearInterval(this.appReportTimer);
            this.appReportTimer = null;
            console.log('Stopped periodic appReport');
        }
    }

    // Cleanup method to be called when the instance is destroyed
    destroy(){
        this.stopPeriodicAppReport();
        // Clear the singleton instance
        Analitika.instance = null;
    }

    // Static method to get existing instance
    static getInstance(){
        return Analitika.instance;
    }

    // Static method to reset singleton (useful for testing)
    static reset(){
        if (Analitika.instance) {
            Analitika.instance.destroy();
        }
        Analitika.instance = null;
    }


    callHermes(str, data){
        if(this.location == 0) return;
        var _this = this;
        var xmlhttp;

        if (window.XMLHttpRequest)
            xmlhttp=new XMLHttpRequest();
        else
            xmlhttp=new ActiveXObject("Microsoft.XMLHTTP");
    
        
        xmlhttp.onreadystatechange=function()
        {
            if (xmlhttp.readyState==4 &&  xmlhttp.status==200)
            {
                console.log('got response from hermes: ' +xmlhttp.responseText);
                
            }
        }

        xmlhttp.open('POST',this.options.hermes_client+"/"+str, true);
        //xmlhttp.setRequestHeader("Content-Type", "application/json");
        xmlhttp.send(JSON.stringify(data));

    }
    /*
    formatMemory(bytes){
        let str = '';
        let remaining = bytes;
        if(remaining > 1000000){
            string += Math.round(remaining/1000000) + "M ";
            remaining = remaining % 1000000;
        }
        if(remaining > 1000){
            string += Math.round(remaining/1000) + "k";
            remaining = remaining % 1000;          
        }
        return str;
    }
    */

    report_js_error(message, source, lineno, colno, error, destination, callback){
        if(this.location < 1)  return false;
        let errstring = '';
        if(error != null && error.stack != undefined) errstring = error.stack;
        let parameters = {location: this.location, destination: destination, app: 'miza2', message: message, source:source, 
                          lineno: lineno, colno: colno, error: errstring};
        //console.log('report_js_error', parameters);
        this.callApi('DeviceManager', 'report_js_error', parameters, function(response){
            console.log('report_js_error response ', response);
            if(typeof(callback) === 'function'){
                callback();
            }
        });
      }

    formatRequest(iface,method, parameters){
        var obj = new Object();
        var request = new Object();
        request.interface = iface;
        request.method = method;
        request.parameters = parameters;
        obj.request = request;
        return JSON.stringify(obj);
    
    }

    getMemory(){
        var memoryInfo = null;
        if(window.performance != undefined && window.performance.memory != undefined && window.performance.memory.jsHeapSizeLimit != undefined)
            memoryInfo = {
                jsHeapSizeLimit: window.performance.memory.jsHeapSizeLimit,
                totalJSHeapSize: window.performance.memory.totalJSHeapSize,
                usedJSHeapSize: window.performance.memory.usedJSHeapSize
            };
       return memoryInfo;
    }


}
